import { useOrderSocketEventsForMe } from "@@/backoffice/for-providers/orders/use-order-socket-events-for-me";
import { Conditional } from "@@/shared/conditional";
import { VerticalDivider } from "@@/shared/dividers";
import { FlexColumn, FlexRow } from "@@/shared/flex-containers";
import { useTicketForOrder } from "@@/tickets/queries/use-ticket";
import { TicketReceiptViewV2 } from "@@/tickets/ticket-receipt-top-view-v2";
import type { Order, OrderItemVoucher } from "@towni/common";
import { motion } from "framer-motion";

type Props = {
    order: Order;
    orderItems: OrderItemVoucher[];
};

const DigitalVoucherReceipt_Tickets_V2 = (props: Props) => {
    const { order, orderItems: _voucher } = props;
    const [orderTickets, ticketQuery] = useTicketForOrder(order._id);
    const tickets = orderTickets; //.filter(t => t.productId === voucher.productId);
    // Listen to order events and if the order has changes then
    // refetch tickets in case anything has happened with them as well
    useOrderSocketEventsForMe({
        onOrderEvent: (event, _room) => {
            if (event.data.orderId === order._id) {
                ticketQuery.refetch();
            }
        },
    });

    return (
        <>
            <VerticalDivider S />
            <Conditional
                when={!!tickets.length}
                render={() => (
                    <motion.div
                        initial={{
                            height: 0,
                            opacity: 0,
                        }}
                        animate={{
                            height: "auto",
                            opacity: 1,
                        }}
                        exit={{ opacity: 0 }}>
                        <FlexRow>
                            <FlexColumn
                                grow={1}
                                shrink={0}
                                padding={{ leftRight: 10 }}>
                                <TicketReceiptViewV2 tickets={tickets} />
                            </FlexColumn>
                        </FlexRow>
                    </motion.div>
                )}
            />
        </>
    );
};

export { DigitalVoucherReceipt_Tickets_V2 };
